import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysTasRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [tasData, tasUsedAmount, dataSourceInfo] = await Promise.all([
      this.reimaginedData.fetchTasData(),
      this.reimaginedData.fetchTasUsedAmount(),
      this.reimaginedData.getDataSourceInfo(),
    ]);

    return {
      tasData,
      tasUsedAmount,
      dataSourceInfo,
    };
  }
}
